import { isResourceOfType } from '@opallabs/api'
import { TextEditorAsset } from '../../types'
import { RichTextDocument, useRichText } from '../useRichText'

type UseRichTextAssetsParams = {
  documentId: string
  enabled?: boolean
}

const selectAssets = (document?: RichTextDocument): TextEditorAsset[] => {
  if (!document?.included) return []

  const assets = document.included.filter(isResourceOfType('asset', 'V3'))

  return assets.map<TextEditorAsset>((asset) => ({
    assetUuid: asset.id,
    // NOTE: The `image` fallback ensures compatibility when full asset
    // metadata isn't available, such as rich text document assets viewed
    // by non-logged-in users in shared presentations.
    assetType: asset.attributes.mime_type?.split('/')[0] ?? 'image',
    filename: asset.attributes.file_name ?? null,
    filesize: asset.attributes.bytes ?? null,
    format: asset.attributes.mime_type ?? null,
    fullUrl: asset.attributes.url ?? null,
    width: asset.attributes.width ?? null,
    height: asset.attributes.height ?? null,
  }))
}

export const useRichTextAssets = ({
  documentId,
  enabled = true,
}: UseRichTextAssetsParams) => {
  return useRichText({
    documentId,
    enabled,
    select: selectAssets,
  })
}
